import { render, staticRenderFns } from "./roleInfo.vue?vue&type=template&id=c48b2230&"
import script from "./roleInfo.vue?vue&type=script&lang=js&"
export * from "./roleInfo.vue?vue&type=script&lang=js&"
import style0 from "./roleInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports